// extracted by mini-css-extract-plugin
export var Bg = "g_j";
export var aniSpin = "g_d";